import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import contactbanner from "../assets/img/Web_Photo_Editor.jpg"
export const ContactUs = () => {

  const [status, setStatus] = useState("");
  const [contactformdata, setContactformdata] = useState({
    fullname: "",
    courses: "",
    email: "",
    phone: "",
    message: "",
  });
  const handleInputs = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setContactformdata({
      ...contactformdata,
      [name]: value,
    });
  };

  const handleShareClick = () => {
    const textToShare = encodeURIComponent(
      'Check out this awesome link: https://example.com'
    );
    const whatsappUrl = `whatsapp://send?text=${textToShare}`;
    window.location.href = whatsappUrl;
  };
  const phoneNumber = '9926122299'; // Replace with the desired phone number
  const message = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

  // WhatsApp API URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  const phoneNumbers = '9926002299'; // Replace with the desired phone number
  const messages = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

  // WhatsApp API URL
  const whatsappsUrl = `https://wa.me/${phoneNumbers}?text=${encodeURIComponent(messages)}`;

  // const formSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(contactformdata);
  // };
  // console.log(newValue);

  // const PostData = async (e) => {
  //   e.preventDefault();

  //   const { fullname, email, phone, courses, message } = contactformdata;

  //   const res = await fetch("/contact", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       fullname,
  //       email,
  //       phone,
  //       courses,
  //       message
  //     })
  //   });
  //   const data = await res.json();

  //   if (data.status === 422 || !data) {
  //     window.alert("Invalid Data")
  //     console.log("Invalid Data");
  //   }
  //   else {
  //     window.alert("Registration SuccessfUll")
  //     console.log("Registration SuccessfUll");
  //   }
  // };
  const contactform = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_be5k1s1", "template_618ra1q", contactform.current, {
        publicKey: "QSz0QsTM68Bd5HTY3",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  const formSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    try {
      const response = await fetch("http://localhost:5000/send", {
        // Replace with your backend URL
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(contactformdata), // Convert form data to JSON
      });

      // Check if the response is okay
      if (response.ok) {
        setStatus("Message sent successfully!"); // Success message
        // Optionally reset form fields
        setContactformdata({
          name: "",
          email: "",
          message: "",
          phone: "",
          courses: "",
        });
      } else {
        const errorData = await response.json(); // Get error details
        setStatus("Failed to send message: " + errorData.message);
      }
    } catch (error) {
      setStatus("Error: " + error.message); // Display error message
    }
  };

  return (
    <>
      <div className="about-carousel">
        <div className="about-carousel-inner">
          <div className="about-carousel-item">
            <img src={contactbanner} alt="About Banner" />
            <div className="about-carousel-content">
              <h2>Contact Us</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="section-header">
        <h3 className="service-header-title">Keep In
          Touch</h3>
        <p>
          For any query or product related information please fill the details below and we shall contact you within 24 hours.
        </p>
        <div className="line-mf"></div>
      </div>
      <section className="contact-container">

        <div className="container-forms">


          <form onSubmit={sendEmail} method="POST" className="forms-container">
            <div className="contacts">
              <span className="contact-input">
                <span>
                  Full Name <label>*</label>
                </span>
                <input
                  type="text"
                  name="fullname"
                  autoComplete="off"
                  value={contactformdata.fullname}
                  onChange={handleInputs}
                  required
                />
              </span>

              <span className="contact-input">
                <span>
                  Company Name<label>*</label>
                </span>
                <input
                  type="text"
                  name="phone"
                  autoComplete="off"
                  value={contactformdata.phone}
                  onChange={handleInputs}
                />
              </span>
            </div>
            <div className="contacts">
              <span className="contact-input">
                <span>
                  Email <label>*</label>
                </span>
                <input
                  type="email"
                  name="email"
                  autoComplete="off"
                  value={contactformdata.email}
                  onChange={handleInputs}
                  required
                />
              </span>
              <span className="contact-input">
                <span>
                  Phone Number <label>*</label>
                </span>
                <input
                  type="number"
                  name="phone"
                  autoComplete="off"
                  value={contactformdata.phone}
                  onChange={handleInputs}
                />
              </span>


            </div>
            <div className="contact-input">
              <span>
                Subject <label>*</label>
              </span>
              <input
                type="text"
                name="subject"
                autoComplete="off"
                value={contactformdata.subject}
                onChange={handleInputs}
              />
            </div>
            <div className="contact-input">
              <span>
                Write Your Message <label>*</label>
              </span>
              <textarea
                rows="5"
                name="message"
                autoComplete="off"
                value={contactformdata.message}
                onChange={handleInputs}
              ></textarea>
            </div>
            <button className="primary-btn">Submit Now</button>
            {status && <p>{status}</p>}
          </form>
          <div className="side-contents">
            {/* <h2 className="contact-title">Contact Details</h2> */}
            {/* <p className="contact-desc">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Praesentium illo vel quam repellendus rem magni a ducimus in
            accusamus dolorum minima, nihil molestiae hic fugit consequuntur
            quae culpa, nesciunt adipisci?
          </p> */}
            <h3>Registered Address:</h3>

            <div className="contactcont-area">
              <p>
                <i className="fa fa-map-marker-alt"></i>
                <div>
                  <p>Earthy Fusion Pvt Ltd</p>
                  {/* <br /> */}
                  G-2/50, Sirsi Rd, RFC Colony, Hanuman Nagar Extension, Krishna Nagar, Vaishali Nagar, Jaipur, Rajasthan 302021
                </div>
              </p>
            </div>
            <h3>Email:</h3>
            <div className="contactcont-area">
              <span className="">
                <i className="fa fa-envelope"></i>Info@earthyfusionpvtltd.com
              </span>
              <span className="">
                <i className="fa fa-envelope"></i>earthyfusionpvtltd@gmail.com
              </span>
            </div>
            <h3>Contact Number:</h3>

            <div className="contactcont-area">
              <span>
                <a href={whatsappsUrl} target="_blank" rel="noopener noreferrer" >
                  <i class="fa-brands fa-square-whatsapp"></i>+91 9926122299 (Mr. Akash Kaushik)
                </a>


              </span>
              <span>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
                  <i class="fa-brands fa-square-whatsapp"></i>+91 9926002299 (Mr. Ankur Kaushik)
                </a>


              </span>
            </div>
            <h3>Social Media:</h3>

            <div className="contact-social">
              <div className="icon">
                <Link to="https://www.facebook.com/profile.php?id=61566816340589">
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link to="https://www.instagram.com/earthyfusion/">
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link to="https://in.linkedin.com/company/earthy-fusion-private-limited/">
                  <i className="fab fa-linkedin"></i>
                </Link>

                <Link to="https://twitter.com/earthyfusion">
                  <i className="fa-brands fa-x-twitter"></i>
                </Link>

              </div>
            </div>
          </div>
        </div>
        <div class="mapswrapper"><iframe width="1000" height="450" loading="lazy" allowfullscreen src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=G-2%2F50%2C%20Sirsi%20Rd%2C%20RFC%20Colony%2C%20Hanuman%20Nagar%20Extension%2C%20Krishna%20Nagar%2C%20Vaishali%20Nagar%2C%20Jaipur%2C%20Rajasthan%20302021&zoom=10&maptype=roadmap"></iframe><a href="https://www.taxuni.com/virginia-income-tax-brackets/">Earthy Fusion Pvt Ltd</a></div>


        {/* </iframe> */}
      </section>
      <div className="contactus-cards-container">
        <div className="section-header">
          <h3 className="service-header-title" style={{ color: "#fafbfc" }}>Contact US</h3>
        </div>
        <div className="contactus-cards">
          <div className="contactus-card">
            <div><p><i class="fa fa-user" aria-hidden="true"></i>Mr. Akash Kaushik (Sales & Marketing)</p></div>
            <div><p> <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
              <i class="fa-brands fa-square-whatsapp"></i>+91 9926122299 (Mr. Ankur Kaushik)
            </a></p></div>
            <div><p><i className="fa fa-envelope"></i>info@earthyfusionpvtltd.com</p></div>
          </div>
          <div className="contactus-card">
            <div><p><i class="fa fa-user" aria-hidden="true"></i>Mr. Ankur Kaushik (Sales & Marketing)</p></div>
            <div><p> <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
              <i class="fa-brands fa-square-whatsapp"></i>+91 9926002299 (Mr. Ankur Kaushik)
            </a></p></div>
            <div><p><i className="fa fa-envelope"></i>sales@earthyfusionpvtltd.com</p></div>
          </div>

        </div>
      </div>
      {/* </iframe> */}
    </>
  );
};
